<template>
    <div id="description" class="row">
        <div class="col-md-8 mb-5">
            <h2>Opdracht</h2>
            <div class="table-responsive">
                <table class="table table-sm table-striped">
                    <thead class="thead-azure-dark">
                        <tr>
                            <th>Datum</th>
                            <th>Aanvang</th>
                            <th>Uren</th>
                        </tr>
                    </thead>
                    <tbody v-for="d in assignment.dates" :key="d.id">
                        <tr>
                            <td>{{new Date(d.date).toLocaleDateString()}}</td>
                            <td>{{new Date(d.startTime).toLocaleTimeString()}}</td>
                            <td>{{d.hours}}</td>
                        </tr>
                        <tr v-if="completed">
                            <td colspan="3">
                                <div class="input-group input-group-sm">
                                    <input class="form-control form-control-sm" type="number" v-model="d.actualHours" :disabled="d.lockedHours" placeholder="Werkelijk gewerkte uren..."  />
                                    <div class="input-group-append">
                                        <button class="btn btn-azure-dark btn-sm" @click="updateHours(d)" :disabled="d.lockedHours" >Versturen</button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th :colspan="2" class="pt-3">{{assignment.city}}</th>
                            <th class="pt-3">{{assignment.hours}}</th>
                        </tr>
                    </tfoot>
                </table>
                <hr>
                <div class="row mt-3 mb-5" v-if="completed" hidden>
                    <label class="col-form-label col-12 col-md-4">Werkelijke uren:</label>
                    <div class="col-12 col-md-8">
                        <div class="input-group">
                            <input class="form-control" type="number" v-model="hours" />
                            <div class="input-group-append">
                                <button class="btn btn-azure-dark" @click="updateHours">Versturen</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h5 class="mt-3">Omschrijving</h5>
            {{assignment.description}}
        </div>
        <div class="col-md-4 card p-4">
            <h2 class="mb-3">Opdrachtgever</h2>
            <div>
                <div class="text-center mb-5" v-if="!!assignment.clientProfileImage">
                    <img class="img-fluid img-thumbnail rounded-circle img-profile" width="50%"
                    :src="'data:' + assignment.clientProfileImage.fileContentType + ';base64,' + assignment.clientProfileImage.file" />
                </div>
                <address :class="{ 'text-center': completed }">
                    <strong>{{assignment.clientCompany}}</strong> <br>
                    <span v-if="!completed">
                        {{assignment.clientName}}<br>
                        <abbr title="Telefoon">T:</abbr>&nbsp;{{assignment.clientPhone}} <br>
                        <abbr title="Email">E:</abbr>&nbsp;<a :href="'mailto:'+ assignment.clientEmail">{{assignment.clientEmail}}</a> <br>
                    </span>
                </address>
            </div>
        </div>
    </div>
</template>

<script>

export default 
{
    data() {
        return {
            hours: 0,
        }
    },
    mounted() {
        this.hours = this.assignment.actualHours || this.assignment.hours;
    },
    methods: {
        updateHours(d) {
            this.$http.post('api/Assignments/Hours/' + this.assignment.id, { date: d.date, hours: d.actualHours }).then(() => {
                d.lockedHours = true;
            });
        }
    },
    computed: {
        assignment() {
            return this.$parent.assignment;
        },
        completed() {
            return this.$parent.completed;
        }
    },
    watch: {
        assignment(to)
        {
            if(to != null) 
                this.hours = to.actualHours || to.hours;
        }
    }
}
</script>